import React from "react";
import { IonLabel, IonSelect, IonSelectOption, IonText } from "@ionic/react";
import { Controller } from "react-hook-form";
import { IControlData, ISelectOption, ISelectWrapperData } from "../../models/Control";
import classNames from "classnames";
import InputError from "../utils/InputError";
import InputHint from "../utils/InputHint";

interface IProps {
  name: string;
  label: string | null;
  controlData: IControlData;
  selectData: ISelectWrapperData;
  options: ISelectOption[];
  error?: any;
  hint?: string;
}

const SelectWrapper: React.FC<IProps> = ({ name, error, label, controlData, selectData, options, hint }) => {
  return (
    <div className={classNames("ion-stack vertical", error ? "error" : "")}>
      <IonLabel>
        {label}
        {controlData?.rules?.required?.value === true ? <IonText color="danger">*</IonText> : null}
      </IonLabel>
      <Controller
        name={name}
        render={({ field: { value, onChange } }) => (
          <IonSelect
            interfaceOptions={{
              message: label,
            }}
            onIonChange={(event) => {
              if (selectData.multiple) {
                if (Array.isArray(event.detail.value)) {
                  let previousValue = [...(value ?? [])];
                  let newValue = [...event.detail.value];

                  let hasMissingItem = false;
                  newValue.forEach((val: any) => {
                    if (!previousValue.includes(val)) {
                      hasMissingItem = true;
                    }
                  });

                  if (hasMissingItem || previousValue.length !== newValue.length) {
                    onChange(event.detail.value);
                  }
                }
              } else {
                onChange(event.detail.value);
              }
            }}
            okText="Rendben"
            cancelText="Mégse"
            name={name}
            value={value}
            placeholder="Válasszon..."
            {...selectData}
          >
            {options.map((option) => (
              <IonSelectOption key={option.key} value={option.key}>
                {option.name}
              </IonSelectOption>
            ))}
          </IonSelect>
        )}
        {...controlData}
      />
      {error && <InputError>{error.message?.toString() ?? ""}</InputError>}
      {hint && <InputHint>{hint}</InputHint>}
    </div>
  );
};

export default SelectWrapper;
